import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import AppLocale from "../../config/lang";

export default (context) => {
  const M = "admGroup.";
  const L = AppLocale['en'].messages;
  let ctxSubFormDetailGrid = null;
  let ctxParentForm = null;

  // Extract the import users subform configuration
  const createImportUsersSubform = () => ({
    size: "md",
    name: `admFlow.fromCSV`,
    wrapClassName: "mb-4",
    fields: [
      {
        col: 12,
        name: "tabs",
        value: "copyPaste",
        type: "tabs",
        tabs: [
          {
            id: "copyPaste",
            name: `admFlow.copyPaste`,
            fields: [
              {
                col: 4,
                name: "inputType",
                type: "radio",
                label: "External IDs", 
                value: "externalIds",
                rules: "required",
                opts: {
                  default: "externalIds",
                  value: "externalIds" 
                }
              },
              {
                col: 4,
                name: "inputType",
                type: "radio",
                label: "Phone Numbers", 
                rules: "required",
                opts: {
                  value: "phoneNumbers" 
                }
              },
              {
                col: 4,
                name: "inputType",
                type: "radio",
                label: "Native IDs", 
                rules: "required",
                opts: {
                  value: "nativeIds"
                }                   
              },
              {
                col: 12,
                name: "idsList",
                value: "",
                type: "textarea",
                label: (L, state) => {
                  if (state.inputType === "phoneNumbers") return "Phone Numbers"
                  if (state.inputType === "externalIds") return "External IDs"
                  return "Native IDs"
                },
                placeholder: (L, state) => {
                  if (state.inputType === "phoneNumbers") return "Example:\n+51963214569\n+51969875563\n+51963369852"
                  if (state.inputType === "externalIds") return "Example:\n1234\n51963\n69852"
                  return "Example:\n1\n2\n3"
                },
                rules: "required",
                opts: {
                  rows: "12"
                },
                renderIf: ctx => ctx.state.inputType !== "phoneNumbers"
              },
              {
                col: 12,
                name: "phoneList",
                value: "",
                type: "textarea",
                label: "Phone Numbers",
                placeholder: "Example:\n+51963214569\n+51969875563\n+51963369852",
                rules: "required",
                opts: {
                  rows: "12"
                },
                renderIf: ctx => ctx.state.inputType === "phoneNumbers"
              }
            ]
          },
          {
            id: "fromCSV",
            name: `admFlow.fromCSV`,
            fields: [
              {
                col: 4,
                name: "inputType",
                type: "radio",
                label: "External IDs", 
                value: "externalIds",
                rules: "required",
                opts: {
                  default: "externalIds",
                  value: "externalIds" 
                }
              },
              {
                col: 4,
                name: "inputType",
                type: "radio",
                label: "Phone Numbers", 
                rules: "required",
                opts: {
                  value: "phoneNumbers" 
                }
              },
              {
                col: 4,
                name: "inputType",
                type: "radio",
                label: "Native IDs", 
                rules: "required",
                opts: {
                  value: "nativeIds"
                }                   
              },
              {
                col: 12,
                name: "btnTemplate",
                type: "button",
                label: "main.downloadExcelTemplate",
                onClick: (ctx) => {
                  const filename = ctx.state.inputType === "phoneNumbers" 
                    ? "UsersImport.xlsx" 
                    : "UsersGroupImport.xlsx";
                  const link = document.createElement('a');
                  link.href = `/tplmails/dwn/${filename}`;
                  link.download = filename;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                },
                renderIf: (ctx) => ctx.state.inputType
              },
              {
                col: 12,
                name: "data",
                value: "",
                type: "dropzone",
                rules: "required",
                placeholder: "main.selectFile",
                opts: {
                  accept: '.csv',
                  output: true
                }
              }
            ]
          }
        ]
      }
    ],
    buttons: [
      {
        label: `${M}addNumbers`,
        isMain: true,
        onClick: (ctx) => {
          ctx.validateForm().then(() => {
            context.props.setLoader(true);
            const groupId = context.state.idItemSelected;
            
            // Determine endpoint and body based on inputType
            let endpoint, body;
            
            if (ctx.state.inputType === "phoneNumbers") {
              // Phone numbers - POST to admUser/importAttach
              endpoint = "admUser/importAttach";
              body = {
                phoneList: ctx.state.phoneList || null,
                data: ctx.state.data?.[0]?.value || null,
                groupId: groupId
              };
            } else {
              // Native IDs or External IDs - POST to admGroup/importAttach
              endpoint = "admGroup/importAttach";
              body = {
                data: ctx.state.data?.[0]?.value || null,
                idsList: ctx.state.idsList || null,
                useExternalIds: ctx.state.inputType === "externalIds",
                groupId: groupId
              };
            }

            _axios
              .post(endpoint, body)
              .then(r => {
                if (r.status === 0) {
                  // Handle different close methods based on context
                  if (ctxParentForm) {
                    ctxParentForm.toogleSubForm(0); // Use parent form reference
                    if (ctxSubFormDetailGrid) {
                      ctxSubFormDetailGrid.getData();
                    }
                  } else if (ctx.toggleRight) {
                    ctx.toggleRight(); // For context menu modal
                    context.getData();
                  }
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline');
                context.props.setLoader(false);
              }).catch(e => context.props.setLoader(false));
          })
          .catch(e => { /* console.log(e) */ });
        }
      }
    ]
  });

  return {
    config: {
      pageSize: 50,
      resource: "admGroup",
      params: {
        staff: 0,
      },
      remapRow: (form, responseData) => {
        return { ...form, ID: responseData }
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true,
    },

    // Add row context menu actions
    extras: {
      itemsInRowsTable: [
        {
          icon: 'simple-icon-cloud-upload',
          name: `admFlow.fromCSV`,
          onClick: (rowData, ctx) => {
            context.setState({ idItemSelected: rowData.ID });
          },
          form: createImportUsersSubform()
        },
      ]
    },

    filter: {
      fields: [
        { name: "staff", value: 0, type: "hidden" },
      ],
      buttons: [
        {
          label: "main.applyFilter",
          renderIf: (ctx) => {
            return Number.isInteger(ctx.state.staff);
          },
          onClick: (ctx) => {
            ctx.btnAction("filter");
          },
        },
      ],
    },

    form: {
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "hidden",
        },
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          label: "main.name",
          rules: "required",
          opts: {
            style: "float-label",
          },
        },
        {
          col: 12,
          name: "desc",
          value: null,
          type: "textarea",
          label: "main.desc",
          rules: "max:255",
          opts: {
            style: 'float-label',
            rows: 3
          }
        },
        {
          col: 12,
          name: "members",
          value: null,
          type: "select",
          label: `${M}members`,
          rules: "required",
          opts: {
            style: "float-label",
            path: "admUser/get?type=2&pick=true",
            withImg: true,
            isMulti: true,
            searchOnline: true,
            setOutput: (v) => {
              if (v)
                return v.map((m) => {
                  return { ID: m.value, name: m.label, selected: true };
                });
            },
          },
          renderIf: (ctx) => {
            return false;
          },
        },
        {
          col: 12,
          name: "btnImportUsers",
          type: "button",
          label: `admUser.importBtn`,
          opts: {
            wrapperClassName: "d-flex justify-content-end",
            color: "primary",
            outline: true
          },
          onClick: (ctx) => {
            ctxParentForm = ctx;
            ctx.toogleSubForm(0);
          },
          renderIf: (ctx) => { return context.state.idItemSelected },
        }
      ],

      subforms: [
        createImportUsersSubform()
      ],

      detailGrid: (ctx) => {
        return {
          module: 'admUser',
          embeded: (detailCtx) => {
            ctxSubFormDetailGrid = detailCtx
            return {
              config: {
                pageSize: 40,
                resource: `admUser/group/${context.state.idItemSelected || 0}`,
                customTitle: L[`${M}members`]
              },
          
              actions: {
                delete: true
              },

              columns: [
                {
                  Header: "main.ID",
                  accessor: "ID"
                },
                {
                  Header: "main.name",
                  accessor: "name"
                },
                {
                  Header: "main.lastName",
                  accessor: "last"  
                },
                {
                  Header: "External ID",
                  accessor: "externalId"
                }
              ]
            }
          },
          renderIf: () => context.state.idItemSelected
        }
      }
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID",
      },
      {
        Header: "main.name",
        accessor: "name",
      },
      {
        Header: "admNotification.totalUsers",
        accessor: "count",
      },
    ]
  };
};
